// extracted by mini-css-extract-plugin
export default {"iconwrapper":"IconWrapper_iconwrapper__izLT1"};